module.exports = __webpack_public_path__ + "static/img/bg_shenhe_pass@2x.356d8eee.png";